import { useEffect } from "react";
import { useI18n } from "@/i18n/translations";
import { site } from "@/data/site";

const upsertMeta = (attr: "name" | "property", key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel: string, hreflang: string | null, href: string) => {
  const selector = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]:not([hreflang])`;
  let el = document.head.querySelector<HTMLLinkElement>(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/** SEO per pagina: title, description, Open Graph, canonical e hreflang IT/EN. */
export const Seo = ({ titleKey, descKey, path }: { titleKey: string; descKey: string; path: string }) => {
  const { lang, t } = useI18n();

  useEffect(() => {
    const title = t(titleKey);
    const desc = t(descKey);
    const url = `${site.url}${path === "/" ? "/" : path}${lang === "en" ? "?lang=en" : ""}`;
    document.title = title;
    upsertMeta("name", "description", desc);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", `${site.url}/og-image.png`);
    upsertMeta("property", "og:locale", lang === "en" ? "en_GB" : "it_IT");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", desc);
    upsertMeta("name", "twitter:image", `${site.url}/og-image.png`);
    upsertLink("canonical", null, `${site.url}${path === "/" ? "/" : path}`);
    upsertLink("alternate", "it", `${site.url}${path === "/" ? "/" : path}`);
    upsertLink("alternate", "en", `${site.url}${path === "/" ? "/" : path}?lang=en`);
    upsertLink("alternate", "x-default", `${site.url}${path === "/" ? "/" : path}`);
  }, [lang, titleKey, descKey, path, t]);

  return null;
};
